/**
 * Trunnion AI - Dashboard Page
 */

import { DashboardView } from '@/components/dashboard/DashboardView';

export default function DashboardPage() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Dashboard</h1>
        <p className="mt-1 text-sm text-trunnion-slate-400">
          Trunnion AI platform overview and operational status.
        </p>
      </div>
      <DashboardView />
    </div>
  );
}
